import { EventBus, TypeEventBus } from "../../core/utils";

 export function showConfirmDialog(title: string, message: string): Promise<boolean> {
  return new Promise((resolve) => {
    EventBus.$emit(TypeEventBus.CONFIRM_DIALOG, { title, message, resolve });
  });
}

export function showSuccessSnackbar(message: string, timeout = 4000) {
  EventBus.$emit(TypeEventBus.SNACKBAR, {
    message,
    color: 'success',
    timeout,
    showClose: true,
  });
}

export function showErrorSnackbar(message: string, timeout = 4000) {
  EventBus.$emit(TypeEventBus.SNACKBAR, {
    message,
    color: 'error',
    timeout,
    showClose: true,
  });
}

export function showInfoSnackbar(message: string, timeout = 6000) {
  EventBus.$emit(TypeEventBus.SNACKBAR, {
    message,
    color: 'info',
    timeout,
    showClose: true,
  });
}

export function showHighCloudyConfirmDialog(message: string): Promise<boolean> {
  return new Promise((resolve) => {
    EventBus.$emit(TypeEventBus.HIGH_CLOUDY_CONFIRM_DIALOG, { message, resolve });
  });
}